<!-- 编辑学历 -->
<template>
  <div class="edit-boxs">
    <!-- 学校名称 -->
    <div class="edit-item">
      <p>学校名称</p>
      <input type="text" placeholder="请输入学校名称" class="printf-input" v-model="school" />
    </div>
    <!-- 学历 -->
    <div class="edit-item degree" @click="showPicker=true">
      <div>
        <p>学历</p>
        <input type="text" placeholder="如：本科" class="printf-input" disabled v-model="degree" />
      </div>
      <img src="@/assets/img/position/into.png" class="back" />
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="columnList"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <!-- 专业 -->
    <div class="edit-item">
      <p>所学专业</p>
      <input type="text" placeholder="请填写专业" class="printf-input" v-model="profession" />
    </div>

    <!-- 时间段 -->
    <div class="edit-item degree" @click="timeShow">
      <div>
        <p>时间段</p>
        <input type="text" placeholder="请选择时间段" class="printf-input" v-model="times" disabled />
      </div>
      <img src="@/assets/img/position/into.png" class="back" />
    </div>
    <van-popup v-model="showPickers" round position="bottom">
      <van-picker
        title="教育经历"
        show-toolbar
        value-key="name"
        :columns="degreeTime"
        @confirm="selectTime"
        @cancel="showPickers=false"
        @change="changeTime"
        ref="picker"
      />
    </van-popup>
  </div>
</template>

<script>
import { eductionDetails, getKindArray } from "@/api/apiData";
import { Toast } from "vant";
export default {
  components: {},
  data() {
    return {
      school: "", //学校名称
      showPicker: false, //学历选择弹窗
      showPickers: false, //时间段弹窗
      columnList: [],
      degree: "",
      timeValue: [],
      profession: "", //所学专业
      education: "", //学历id
      degreeTime: [
        { values: [], defaultIndex: 1 },
        { values: [], defaultIndex: 1 }
      ],
      times: "", //时间段
      id: "" //查询教育经历详情
    };
  },
  computed: {
    paramsList() {
      var that = this;
      let { school, profession, education, timeValue } = that;
      var info = [];
      info[0] = school.replace(/[, ]/g, "");
      info[1] = education;
      info[2] = profession.replace(/[, ]/g, "");
      info[3] = timeValue;
      return info;
    }
  },
  watch: {
    showPickers() {
      this.getTime();
    },
    paramsList: {
      handler(newName, oldName) {
        var that = this;
        var paramsList = that.paramsList;
        if (
          paramsList[0] != "" &&
          paramsList[1] != "" &&
          paramsList[2] != "" &&
          paramsList[3] != ""
        ) {
          that.$emit("sendEduction", paramsList, false);
        }
      },
      immediate: true
    }
  },
  methods: {
    // 时间弹窗
    timeShow() {
      var that = this;
      var degree = that.degree;
      if (degree == "") {
        Toast("请先选择学历！");
      } else {
        that.showPickers = true;
      }
    },
    changeTime(e, value, index) {
      var that = this;
      var degree = that.degree;
      var idx = that.$refs.picker.getColumnIndex(0);
      if (index == 0) {
        if (degree == "本科") {
          that.$refs.picker.setColumnIndex(1, idx + 4);
        } else {
          that.$refs.picker.setColumnIndex(1, idx + 3);
        }
      }
    },
    //   获取时间
    getTime() {
      var that = this;
      var date = new Date();
      var Y = date.getFullYear();
      var nowYear = Y;
      var Ys = date.getFullYear() - 1;
      var values = [];
      var late = [];
      var degree = that.degree;
      for (var i = 0; i < 30; i++) {
        Y--;
        if (Y == 1990) {
          Y = "1990及以前";
        }
        values.push(Y);
      }
      for (var i = 0; i < 30; i++) {
        Ys++;
        late.push(Ys);
      }
      late.sort();
      values.sort();
      var timeArr = [...values, ...late];
      that.degreeTime[0].values = timeArr;
      that.degreeTime[1].values = timeArr;
      that.degreeTime[0].defaultIndex = 30;
      that.degreeTime[1].defaultIndex = 33;
      switch (degree) {
        case "本科":
          that.degreeTime[0].defaultIndex = 30;
          that.degreeTime[1].defaultIndex = 34;
          break;
      }
    },
    //   学历选择
    onConfirm(value) {
      this.degree = value.name;
      this.education = value.category_id;
      this.showPicker = false;
    },
    // 教育时间选择
    selectTime(val) {
      var that = this;
      var time = val.toString().replace(/,/g, "-");
      that.times =`${val[0]}-09 ~ ${val[0]}-07`
      that.timeValue = val;
      that.showPickers = false;
    },
    // 教育详情
    getEdcutionDetails() {
      var that = this;
      var id = that.id;
      eductionDetails({ resume_education_id: id }).then(res => {     
        if (res.code == 1) {
          that.school = res.data.school;
          that.degree = res.data.education_name;
          that.profession = res.data.speciality;
          that.times = res.data.start_time + "-" + res.data.end_time;
          that.timeValue = [res.data.start_time,res.data.end_time];
          that.education=res.data.education;
        }
      });
    },
    // 获取学历列表
    getEductionList() {
      var that = this;
      getKindArray({ key: "education" }).then(res => {
        if (res.code == 1) {
          that.columnList = res.data;
        } else {
          Toast(res.msg);
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        }
      });
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.getTime();
  },
  mounted() {
    this.getEductionList();
    if (this.$route.params.title == 1) {
      this.getEdcutionDetails();
    }
  }
};
</script>
<style lang='less' scoped>
.edit-boxs {
  padding: 0.2rem 0.44rem;
  font-size: 0.3rem;
  text-align: left;
  .edit-item {
    padding: 0.36rem 0;
    border-bottom: 0.01rem solid rgba(229, 229, 229, 1);
    p {
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.37rem;
      color: rgba(128, 128, 128, 1);
    }
    .printf-input {
      font-weight: bold;
      line-height: 0.42rem;
      color: rgba(51, 51, 51, 1);
      width: 100%;
      margin-top: 0.1rem;
      background: #fff;
    }
    .printf-input::-webkit-input-placeholder {
      font-weight: 400;
      line-height: 0.42rem;
      color: rgba(204, 204, 204, 1);
    }
  }
  .degree {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>